import React from 'react';
import Box from '@mui/material/Box';
import TwDialog from '../../../../components/TwDialog/TwDialog';
import TwBackdrop from '../../../../components/TwBackdrop/TwBackdrop';
import Typography from '@mui/material/Typography';
import { TwButton, TwButtonType } from '../../../../components/TwButtons/TwButtons';
import RefreshIcon from '@mui/icons-material/Refresh';

interface EiaFuelPriceHistoryModalProps {
  showError?: boolean;
  isLoading: boolean;
  isFetching: boolean;
  areaName: string;
  open: boolean;
  onClose: () => void;
  onRetry: () => void;
}

export const LoadingEiaPriceModal: React.FC<EiaFuelPriceHistoryModalProps> = ({
  areaName,
  open,
  showError,
  isLoading,
  isFetching,
  onClose,
  onRetry
}) => {
  return (
    <TwDialog
      open={open}
      title={`EIA - ${areaName}`}
      actionsAlignment="flex-end"
      actions={[]}
      onClickClose={onClose}
    >
      <Box>
        {showError && !isFetching && !isLoading && (
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            <Typography
              variant="h6"
              fontSize="18px"
              sx={{ mt: 2, color: 'text.secondary', textAlign: 'center' }}
            >
              Error loading price data, please try again.
            </Typography>
            <TwButton
              label={'Retry'}
              action={onRetry}
              type={TwButtonType.primary}
              startIcon={<RefreshIcon />}
            />
          </Box>
        )}
        {(isFetching || isLoading) && (
          <>
            <TwBackdrop isOpen={true} />
            <Typography
              variant="h6"
              fontSize="18px"
              sx={{ mt: 2, color: 'text.secondary', textAlign: 'center' }}
            >
              Loading price data ...
            </Typography>
            <Typography
              variant="h6"
              fontSize="14px"
              sx={{ mb: 2, color: 'text.secondary', textAlign: 'center' }}
            >
              We are retrieving diesel prices from EIA. This may take a moment to display.
            </Typography>
          </>
        )}
      </Box>
    </TwDialog>
  );
};
